import { useState, useEffect } from "react";
import Dashboard from "./pages/Dashboard.jsx";
import MachineDetail from "./pages/MachineDetail.jsx";
import WorkOrders from "./pages/WorkOrders.jsx";
import MaintenancePlans from "./pages/MaintenancePlans.jsx";
import Login from "./pages/Login.jsx";

export default function App() {
  const [page, setPage] = useState("dashboard");
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("kb_user");
    const token = localStorage.getItem("kb_token");
    if (stored && token) {
      setUser(JSON.parse(stored));
    }
    setAuthLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setPage("dashboard");
  };

  const handleLogout = () => {
    localStorage.removeItem("kb_token");
    localStorage.removeItem("kb_user");
    setUser(null);
    setPage("dashboard");
  };

  if (authLoading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  if (page === "machine" && selectedMachine) {
    return (
      <MachineDetail
        machine={selectedMachine}
        user={user}
        onBack={() => {
          setPage("dashboard");
          setSelectedMachine(null);
        }}
      />
    );
  }

  if (page === "workorders") {
    return <WorkOrders onBack={() => setPage("dashboard")} user={user} />;
  }

  if (page === "maintenance") {
    return <MaintenancePlans onBack={() => setPage("dashboard")} user={user} />;
  }

  return (
    <Dashboard
      onSelectMachine={(m) => {
        setSelectedMachine(m);
        setPage("machine");
      }}
      onNavigate={setPage}
      user={user}
      onLogout={handleLogout}
    />
  );
}
